import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Statistic, Row, Col, Table, message } from 'antd';
import api from '../../../utils/api';

const { Title, Paragraph } = Typography;

const GrowthMetrics = () => {
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState({ users: 0, agencies: 0, clients: 0, whitelabel_agencies: 0 });
  const [rows, setRows] = useState([]);

  const columns = [
    { title: 'Date', dataIndex: 'date', key: 'date' },
    { title: 'New Users', dataIndex: 'new_users', key: 'new_users' },
    { title: 'New Agencies', dataIndex: 'new_agencies', key: 'new_agencies' },
    { title: 'New Clients', dataIndex: 'new_clients', key: 'new_clients' },
    { title: 'New Whitelabel Agencies', dataIndex: 'new_whitelabel_agencies', key: 'new_whitelabel_agencies' },
  ];

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const resp = await api.get('/analytics/growth-metrics?days=14');
        setSummary(resp?.summary || { users: 0, agencies: 0, clients: 0, whitelabel_agencies: 0 });
        setRows(Array.isArray(resp?.items) ? resp.items : []);
      } catch (e) {
        message.error(e.message || 'Failed to load growth metrics');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Admin' }, { title: 'Analytics' }, { title: 'Platform Growth' }]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Platform Growth Metrics</Title>
      </div>

      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col xs={24} md={6}><Card><Statistic title="Total Users" value={summary.users} /></Card></Col>
        <Col xs={24} md={6}><Card><Statistic title="Total Agencies" value={summary.agencies} /></Card></Col>
        <Col xs={24} md={6}><Card><Statistic title="Total Clients" value={summary.clients} /></Card></Col>
        <Col xs={24} md={6}><Card><Statistic title="Total Whitelabel Agencies" value={summary.whitelabel_agencies} /></Card></Col>
      </Row>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>Daily growth snapshots. Replace with analytics API.</Paragraph>
        <Table rowKey="date" columns={columns} dataSource={rows} loading={loading} pagination={false} />
      </Card>
    </div>
  );
};

export default GrowthMetrics;
